export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Character',
  type: 'place',
  bodyClasses: 'resource-with-embedded-content',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
    ],
    content: [
      {
        id: 'embedded-content-maps',
        type: 'embedded-content',
      },
      {
        id: 'metadata',
        type: 'metadata',
        title: ''
      },
      {
        id: 'collection-antroponimi',
        type: 'collection',
        grid: 3,
        title: 'resource#collection-antroponimi'
      },
      {
        id: 'metadata-occurences',
        type: 'metadata',
        // grid: 1,
        title: 'resource#occurences',
        options: {
          readmore: {
            height: 250,
            labels: {
              more: 'readmore#more',
              less: 'readmore#less'
            }
          }
        }
      },
    ],
  },
};
